"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancellationInfoToString = exports.PERSONAL_COMBO_CANCELLATION_INFO = exports.PERSONAL_COMBO_CANCELLATION_REASON = exports.COMBO_BROKEN_CANCELLATION_INFO = exports.RIDE_ASSIGNATION_CANCELLED_CANCELLATION_INFO = exports.TRANSPORTATION_OFFER_CHANGED_CANCELLATION_INFO = exports.NO_ACCEPTED_TRANSPORTATION_OFFER_CANCELLATION_INFO = exports.MISMATCH_BETWEEN_ORDERS_AND_ASSIGNATIONS_CANCELLATION_INFO = exports.DIFFERENT_RIDE_CANCELLATION_INFO = exports.DRIVER_REASSIGNED_CANCELLATION_INFO = exports.TRIP_CANCELLATION_INFO = exports.VEHICLE_CHANGED_CANCELLATION_INFO = exports.VEHICLE_REMOVED_CANCELLATION_INFO = exports.ASSIGNATION_CANCELLATION_REASONS = exports.ASSIGNATION_CANCELLATION_CATEGORIES = exports.CANCELLATION_CATEGORIES = void 0;
exports.CANCELLATION_CATEGORIES = ["Customer", "Driver", "Support"];
exports.ASSIGNATION_CANCELLATION_CATEGORIES = exports.CANCELLATION_CATEGORIES;
exports.ASSIGNATION_CANCELLATION_REASONS = {
    Customer: [
        "Connection issue (flight, train, ship etc...)",
        "Booked somewhere else",
        "No-show",
        "Upset with Daytrip about another trip",
        "Upset with Daytrip about the payment issue",
        "Medical",
        "Other",
    ],
    Driver: ["Unavailable", "Bad price", "Illness", "Personal", "Mechanical issue", "No-show", "Late pick up", "Other"],
    Support: ["Mistake", "Changing trips/assignations", "Other"],
};
const createAutomatedCancellationInfo = (reason) => ({
    category: "Automated cancellation",
    reason,
});
exports.VEHICLE_REMOVED_CANCELLATION_INFO = createAutomatedCancellationInfo("This vehicle category was removed");
exports.VEHICLE_CHANGED_CANCELLATION_INFO = createAutomatedCancellationInfo("Vehicle category has been changed");
exports.TRIP_CANCELLATION_INFO = createAutomatedCancellationInfo("Trip was cancelled");
exports.DRIVER_REASSIGNED_CANCELLATION_INFO = createAutomatedCancellationInfo("Driver was assigned to the company");
// Ride cancellations
exports.DIFFERENT_RIDE_CANCELLATION_INFO = createAutomatedCancellationInfo("Order was assigned to different ride");
exports.MISMATCH_BETWEEN_ORDERS_AND_ASSIGNATIONS_CANCELLATION_INFO = createAutomatedCancellationInfo("Mismatch between orders and assignations");
exports.NO_ACCEPTED_TRANSPORTATION_OFFER_CANCELLATION_INFO = createAutomatedCancellationInfo("No accepted transportation offer");
exports.TRANSPORTATION_OFFER_CHANGED_CANCELLATION_INFO = createAutomatedCancellationInfo("Transportation offer changed");
exports.RIDE_ASSIGNATION_CANCELLED_CANCELLATION_INFO = createAutomatedCancellationInfo("Ride assignation cancelled");
exports.COMBO_BROKEN_CANCELLATION_INFO = createAutomatedCancellationInfo("Trips can no longer be performed as a Combo");
exports.PERSONAL_COMBO_CANCELLATION_REASON = "Trip reassigned to a personal combo";
exports.PERSONAL_COMBO_CANCELLATION_INFO = createAutomatedCancellationInfo(exports.PERSONAL_COMBO_CANCELLATION_REASON);
const cancellationInfoToString = (info, reason) => {
    if (info) {
        return `${info.category}: ${info.reason}${info.note ? `, ${info.note}` : ""}`;
    }
    return reason ?? "";
};
exports.cancellationInfoToString = cancellationInfoToString;
//# sourceMappingURL=CancellationInfo.js.map